// extracted by mini-css-extract-plugin
module.exports = {"mult-select":"styles_mult-select__FfNir","switch-queue":"styles_switch-queue__TOYzu"};